import * as React from "react";

export const CreateComp = () => <>CreateComp</>;
export default CreateComp;
